import {DprApiImage} from "../ApiImage";
import React from "react";
import {IEditor} from "@webng-types/write-model/index";

export interface EventAuthorProps {
  className?: string
  editor: IEditor
  showByline?: boolean
}

export function EventAuthor({className, editor, showByline}: EventAuthorProps) {

  const currentEditorImage = editor.local_image ?? editor.image
  const currentEditorName = editor.local_name ?? editor.name
  const currentEditorByline = editor.local_byline ?? editor.byline

  return <div className={className || 'tik4-author'}>
    <div className="tik4-author__wrapper">
      <div className="tik4-author__name">
        <div className="tik4-author__name__t">
          {editor.name}
        </div>
        {currentEditorByline && showByline &&
          <div className="tik4-author__name__bl">
            {currentEditorByline}
          </div>
        }
      </div>
      { currentEditorImage &&
        <div className="tik4-author__thumb">
          <DprApiImage
              className="tik4-author__thumb__img"
              alt={currentEditorName}
              image={currentEditorImage}
              width={64}
              height={64}
              fit="cover"
              />
        </div>
      }
    </div>
  </div>;
}

